import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query"
import { signInClient, getUserInfo } from "@/entities/user/api/user.client"
import { ApiResponse } from "@/shared/types/interface/api"
import { SignInRequest } from "@/shared/types/type/sign-in"
import { GetUserInfoResponse, SignInResponse } from "@/shared/types/type/user"

export const useMutationSignIn = (options?: UseMutationOptions<ApiResponse<SignInResponse>, Error, SignInRequest, unknown>) => {
  return useMutation<ApiResponse<SignInResponse>, Error, SignInRequest>({
    mutationFn: signInClient,
    ...options,
  })
}

export const useQueryUserInfo = (options?: Omit<UseQueryOptions<ApiResponse<GetUserInfoResponse>, Error>, "queryKey" | "queryFn">) => {
  return useQuery<ApiResponse<GetUserInfoResponse>, Error>({
    queryKey: ["userInfo"],
    queryFn: getUserInfo,
    ...options,
  })
}
